import React from 'react';

import isEqual from 'lodash/isEqual';

import { DateRangeFormatter, defaultRangePreset } from '@gogame/intl-ts';

const useLabelPeriod = (periodValue) => {
  const { label } =
    React.useMemo(
      () => defaultRangePreset.find(({ value }) => isEqual(value, periodValue)),
      [periodValue]
    ) || {};

  return label;
};

const Period = ({ value }) => {
  const label = useLabelPeriod(value);

  if (label) {
    return label;
  }

  return <DateRangeFormatter value={value} template={'LL'} timeZone={'utc'} />;
};

export default Period;
